@if (timeOut()) {
  <app-timeout></app-timeout>
} @else if (loading()) {
  <div class="flex justify-content-center align-items-center h-full">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
} @else {
  <div
    id="expected-energy-loss-container"
    (click)="navigateToDetail()"
    [ngClass]="{ 'compact-version': compact(), pointer: isCustomerYearly() }"
  >
    <div id="top-row">
      <span class="energyToolWidgetTitle">
        @if (isCustomerYearly()) {
          {{ "expected_energy_loss.yearly_title" | translate }}
        } @else {
          {{ "expected_energy_loss.title" | translate }}
        }

        @if (compact()) {
          {{ "expected_energy_loss.filters.today" | translate }}
        }
      </span>
      @if (!compact() && !isCustomerYearly()) {
        <select class="custom_select" (change)="onChangeTimeSelect($event)" [value]="selectedTimeWindow()">
          <option value="today">
            {{ "expected_energy_loss.filters.today" | translate }}
          </option>
          <option value="yesterday">
            {{ "expected_energy_loss.filters.yesterday" | translate }}
          </option>
          <option value="this_week">
            {{ "expected_energy_loss.filters.this_week" | translate }}
          </option>
          <option value="this_month">
            {{ "expected_energy_loss.filters.this_month" | translate }}
          </option>
        </select>
      }
    </div>

    <div id="display-container">
      <div id="text-container">
        <span>{{ displayedEnergyLoss() }} kWh</span>
        <span>{{ "expected_energy_loss.expected" | translate }} {{ displayedExpectedEnergyLoss() }} kWh</span>
      </div>

      <div
        id="progress-container"
        [ngClass]="{
          'within-expected': getProgress(energyLoss(), expectedEnergyLossPerDay()) < 100,
          'over-expected': getProgress(energyLoss(), expectedEnergyLossPerDay()) > 99,
        }"
      >
        <svg
          width="40"
          height="45"
          class="energy-icon"
          viewBox="0 0 47 45"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.76911 44.7023C9.59162 44.7023 9.41312 44.6574 9.2514 44.565C8.83845 44.3279 8.65282 43.8424 8.80488 43.4008L14.9208 25.6721H8.15189C7.82438 25.6721 7.51721 25.519 7.32599 25.2611C7.13528 25.0033 7.08341 24.6719 7.18716 24.3701L15.2768 0.921489C15.4156 0.518429 15.8037 0.247253 16.241 0.247253H30.4283C30.7558 0.247253 31.063 0.400376 31.2537 0.658216C31.4449 0.916055 31.4968 1.24749 31.3925 1.5488L27.6872 12.2901H38.6832C39.087 12.2901 39.4532 12.5223 39.6149 12.8819C39.7766 13.2415 39.7049 13.6598 39.4308 13.9483L10.5167 44.3842C10.3189 44.5927 10.0458 44.7023 9.76911 44.7023ZM9.56569 23.6963H16.3346C16.6621 23.6963 16.9693 23.8494 17.1605 24.1073C17.3512 24.3651 17.4031 24.6966 17.2993 24.9984L12.2438 39.6542L36.3622 14.2664H26.2739C25.9464 14.2664 25.6392 14.1133 25.4485 13.8554C25.2573 13.5976 25.2054 13.2662 25.3097 12.9649L29.015 2.22303H16.9728L9.56569 23.6963Z"
            [attr.fill]="
              getProgress(energyLoss(), expectedEnergyLossPerDay()) < 100
                ? botevoDesignTokens.primitive?.green?.['400']
                : botevoDesignTokens.primitive?.red?.['500']
            "
          />
        </svg>
        <!-- ? botevoDesignTokens.semantic?.primary?.['400']
                : botevoDesignTokens.semantic?.extend?.critical?.['500'] -->

        <!--img *ngIf="progress < 100" class="energy-icon"
                src="data:image/png;base64,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"-->
        <div class="progress-backdrop">
          <svg height="100" width="100" viewBox="0 0 115 115" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50%" cy="50%" r="40" stroke="#424242" stroke-width="20" fill="none"></circle>
          </svg>
        </div>
        @if (getProgress(energyLoss(), expectedEnergyLossPerDay()) !== undefined) {
          <mat-progress-spinner
            diameter="80"
            strokeWidth="10"
            class="progress"
            color="primary"
            mode="determinate"
            [value]="getProgress(energyLoss(), expectedEnergyLossPerDay())"
          >
          </mat-progress-spinner>
        }
      </div>
    </div>
    @if (!compact() && !isCustomerYearly()) {
      <div class="flex justify-content-between">
        @if (energyCost() !== undefined) {
          <div class="flex align-items-center gap-2">
            <app-svg-icon iconName="coins" iconSize="sm" iconColor="primary"></app-svg-icon>
            <span>
              {{ "expected_energy_loss.costs" | translate }}
              {{ displayedEnergyCosts() }} €
            </span>
          </div>
        }
        <div class="flex align-items-center gap-2">
          <img src="assets/icons/energy_tool.png" alt="CO2" style="width: 24px; height: auto" />

          <span>
            {{ "expected_energy_loss.emissions" | translate }}
            {{ displayedEmissions() }} kg
          </span>
        </div>
      </div>
      <!-- <div>
          (change)="changeMode($event.target.value)" -->
      <!-- <select class="custom_select" value="absolute">
          <option value="absolute">
            {{ "expected_energy_loss.filters.absolute" | translate }}
          </option>
          <option value="per-load-change">
            {{ "expected_energy_loss.filters.per_load_change" | translate }}
          </option>
        </select>
        </div> -->
    }
  </div>
}
